export enum InvestmentHouseCode {
  INTERACTIVE_ISRAEL = "514314350",
  MEITAV_DASH = "513563074",
  ALTSHULER_SHAHAM = "513844524",
  YELIN_LAPIDOT = "512892035",
  MOR = "515471144",
  PHOENIX = "520019609",
  HAREL = "512543074",
  MIGDAL = "510846587",
  IBI = "520039978",
  ANALYST = "520041146",
  SIGMA = "520043574",
  EXCELLENCE = "511974834",
  TAMIR_FISHMAN = "515799096",
  INFINITY = "513635045",
  PSAGOT = "512065308",
}

export const formatInvestmentHouseCode = (code: InvestmentHouseCode | string): string => {
  switch (code) {
    case InvestmentHouseCode.INTERACTIVE_ISRAEL:
      return "אינטראקטיב ישראל";
    case InvestmentHouseCode.MEITAV_DASH:
      return "מיטב דש";
    case InvestmentHouseCode.ALTSHULER_SHAHAM:
      return "אלטשולר שחם";
    case InvestmentHouseCode.YELIN_LAPIDOT:
      return "ילין לפידות";
    case InvestmentHouseCode.MOR:
      return "מור";
    case InvestmentHouseCode.PHOENIX:
      return "הפניקס";
    case InvestmentHouseCode.HAREL:
      return "הראל";
    case InvestmentHouseCode.MIGDAL:
      return "מגדל";
    case InvestmentHouseCode.IBI:
      return "איי.בי.אי.";
    case InvestmentHouseCode.ANALYST:
      return "אנליסט";
    case InvestmentHouseCode.SIGMA:
      return "סיגמא";
    case InvestmentHouseCode.EXCELLENCE:
      return "אקסלנס";
    case InvestmentHouseCode.TAMIR_FISHMAN:
      return "תמיר פישמן";
    case InvestmentHouseCode.INFINITY:
      return "אינפיניטי";
    case InvestmentHouseCode.PSAGOT:
      return "פסגות";
    default:
      return code;
  }
};

export const getAllInvestmentHouseCodes = (): Array<{ value: InvestmentHouseCode; label: string }> => {
  return [
    { value: InvestmentHouseCode.INTERACTIVE_ISRAEL, label: formatInvestmentHouseCode(InvestmentHouseCode.INTERACTIVE_ISRAEL) },
    { value: InvestmentHouseCode.MEITAV_DASH, label: formatInvestmentHouseCode(InvestmentHouseCode.MEITAV_DASH) },
    { value: InvestmentHouseCode.ALTSHULER_SHAHAM, label: formatInvestmentHouseCode(InvestmentHouseCode.ALTSHULER_SHAHAM) },
    { value: InvestmentHouseCode.YELIN_LAPIDOT, label: formatInvestmentHouseCode(InvestmentHouseCode.YELIN_LAPIDOT) },
    { value: InvestmentHouseCode.MOR, label: formatInvestmentHouseCode(InvestmentHouseCode.MOR) },
    { value: InvestmentHouseCode.PHOENIX, label: formatInvestmentHouseCode(InvestmentHouseCode.PHOENIX) },
    { value: InvestmentHouseCode.HAREL, label: formatInvestmentHouseCode(InvestmentHouseCode.HAREL) },
    { value: InvestmentHouseCode.MIGDAL, label: formatInvestmentHouseCode(InvestmentHouseCode.MIGDAL) },
    { value: InvestmentHouseCode.IBI, label: formatInvestmentHouseCode(InvestmentHouseCode.IBI) },
    { value: InvestmentHouseCode.ANALYST, label: formatInvestmentHouseCode(InvestmentHouseCode.ANALYST) },
    { value: InvestmentHouseCode.SIGMA, label: formatInvestmentHouseCode(InvestmentHouseCode.SIGMA) },
    { value: InvestmentHouseCode.EXCELLENCE, label: formatInvestmentHouseCode(InvestmentHouseCode.EXCELLENCE) },
    { value: InvestmentHouseCode.TAMIR_FISHMAN, label: formatInvestmentHouseCode(InvestmentHouseCode.TAMIR_FISHMAN) },
    { value: InvestmentHouseCode.INFINITY, label: formatInvestmentHouseCode(InvestmentHouseCode.INFINITY) },
    { value: InvestmentHouseCode.PSAGOT, label: formatInvestmentHouseCode(InvestmentHouseCode.PSAGOT) },
  ];
};

/**
 * פונקציה לקבלת רשימת בתי השקעות כולל בנקים
 * מחזירה רשימה משולבת של בתי השקעות + בנקים לשימוש בתיק השקעות
 */
export const getAllInvestmentHouseCodesWithBanks = (): Array<{ value: string; label: string }> => {
  const investmentHouses = getAllInvestmentHouseCodes();

  // ייבוא דינמי של הבנקים כדי למנוע circular dependency
  const { getAllBankHandlerCodes } = require('./bankHandlerCodeFormatter');
  const banks = getAllBankHandlerCodes();

  // שילוב שתי הרשימות
  return [...investmentHouses, ...banks];
};
